export const getMenuData = [
  {
    category: true,
    title: "Main",
  },
  {
    title: "Dashboard",
    key: "dashboard",
    url: "/dashboard/alpha",
    icon: "fe fe-home",
  },
  {
    category: true,
    title: "Billing",
  },
  {
    title: "Merchants",
    key: "merchants",
    url: "/billing",
    icon: "fe fe-users",
    // count: 4
    children: [
      {
        title: "Add Merchant",
        key: "add-merchant",
        url: "/billing/merchants/add",
        icon: "fe fe-user-plus",
      },
      {
        title: "Merchant Rotation",
        key: "merchant-rotation",
        url: "/billing/merchants/rotation",
        icon: "fe fe-rotate-cw",
      },
    ],
  },
]
